import axios from 'axios';
import React, { useEffect, useState } from 'react'

const MyAppliedPostCard = ({post}) => {
  const [company, setCompany] = useState({})
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const response = await axios.post(
          "https://kariyer.biyomed.net/api/companies/getOneDetailsCard",
          { company_id: post.company_id }, // `post` propsunu company_id olarak gönderiyoruz
          { withCredentials: true }
        );
        setCompany(response.data.company);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
    };

    if (post) {
      fetchCompany(); // `post` değeri varsa istek yapılır
    }
  }, [post]); // `post` değiştiğinde yeniden çağırır
  const formattedDate = new Date(post?.created_at).toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  return (
    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
    <div className="jp_job_post_main_wrapper_cont jp_job_post_grid_main_wrapper_cont">
      <div className="jp_job_post_main_wrapper jp_job_post_grid_main_wrapper">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_job_post_side_img">
            <img style={{marginLeft:25, marginTop:25, maxHeight:70 , maxWidth:100}}
                src={company.profile_image ? company.profile_image : "https://pbs.twimg.com/profile_images/1305064450848960525/gsJVVM41_400x400.jpg" }
                alt="post_img"
              />
            </div>
            <div className="jp_job_post_right_cont jp_job_post_grid_right_cont">
            <h4>
                  {post.position_name.length > 30 ? post.position_name.slice(0, 30) + "..." : post.position_name}
                </h4>
              <p>{post.company_name} </p>
              <ul>
              <li style={{fontSize:'14px', marginTop:3}}>
                  <i  className="fa fa-calendar" />
                  &nbsp; Başvurma Tarihi: {formattedDate} 
                </li>
                <li style={{fontSize:'14px', marginTop:10, fontWeight:"bold", color:"black",marginBottom:-10 }}>
                  <i  className="fa fa-eye" />
                  &nbsp; Başvuru Görüntülenme Durumu &nbsp; <p style={{color:post.viewed ? "green" : "orange", marginTop:-20}}> {post.viewed ? "Firma Tarafından Görüntülendi" : "Görüntülenmedi"} </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_job_post_right_btn_wrapper jp_job_post_grid_right_btn_wrapper">
              <ul style={{marginTop:40}}>
                <li >

                </li>
                <li >
                  <a style={{marginLeft:120}} href={`/apply-post/${post.id}`}>Başvuruldu</a>
                </li>
                <li>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="jp_job_post_keyword_wrapper">
        <ul>
        <li>
            <i className="fa fa-tags" />
            Etiketler :
          </li>
          <li>
            <a href="/">{post.position_tags}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  )
}

export default MyAppliedPostCard